import React from 'react'

import styles from './footer.module.scss'

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <h1>Footer</h1>
    </footer>
  )
}

export default Footer
